import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  label: string
  oldValue?: string | null
  newValue: string | null
}

const textColor = (value: string | null) => (value ? 'grey1000' : 'grey600')
const oldTextColor = (newValue: string | null) => (newValue ? 'grey600' : 'grey1000')
const translatedTextValue = (value: string | null) =>
  value ?? i18n.t('bookkeepers.incidence.details.empty')

const IncidenceDetailDataChangeLine = ({ label, oldValue, newValue }: Props) => {
  if (!oldValue && !newValue) return null

  const nullableNewValue = newValue ?? null

  return (
    <Box component="li" style={{ display: 'list-item' }}>
      <Box flexDirection="row" flexWrap="wrap" gap="s4">
        <Text.Normal size="200" color="grey800">
          {label}:
        </Text.Normal>

        {/* NOTE: Undefined value means it does not exist while null values means empty */}
        {oldValue !== undefined && (
          <>
            <Text.Normal
              size="200"
              weight="medium"
              color={oldTextColor(nullableNewValue)}
              stroked={oldValue !== null && nullableNewValue !== null}
            >
              {translatedTextValue(oldValue)}
            </Text.Normal>
            <Text.Normal size="200" weight="medium" color="grey800">
              →
            </Text.Normal>
          </>
        )}
        <Text.Normal weight="medium" size="200" color={textColor(nullableNewValue)} overflowWrap>
          {translatedTextValue(nullableNewValue)}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default IncidenceDetailDataChangeLine
